import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { MobileCredentialContent } from "../Component/MobileCredentialContent";

const MobileCredential = () => {
  const seoData = getSEOData("/mobile-credential");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <MobileCredentialContent />
    </>
  );
};

export default MobileCredential;